module.exports = __webpack_public_path__ + "static/media/map2.3c7165b0.jpg";